import { render, staticRenderFns } from "./TheSuppliersHeader.vue?vue&type=template&id=01e556f8"
import script from "./TheSuppliersHeader.vue?vue&type=script&lang=js"
export * from "./TheSuppliersHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports